import React, { useState } from "react";
import { AiFillFileAdd } from "react-icons/ai";
import { Link } from "react-router-dom";
import { RoutePath } from "../../utility/Constant";
import { FaRegEdit } from "react-icons/fa";
import { MdDeleteForever } from "react-icons/md";

function ContactsCard({ project, user, handleSingleDelete }) {
  const { contactList, contactListAdd } = RoutePath;
  const [showMore, setShowMore] = useState(false);
  const [visibility, setVisibility] = useState(true);

  const handleDelete = async () => {
    const res = await handleSingleDelete(project._id);
    if (res === true) {
      setVisibility(false);
    }
  };

  return (
    <>
      {visibility && (
        <div className="group relative border flex flex-col justify-between overflow-hidden shadow-lg rounded-lg h-full bg-white">
          {project ? (
            <div className="p-4 flex flex-col justify-between h-full gap-3">
              {/* Country Title */}
              <h2 className="text-lg font-semibold">{project.country}</h2>

              {/* Address */}
              <div className="text-gray-600">
                <p>
                  {showMore
                    ? project.address
                    : `${project.address?.substring(0, 100)}${
                        project.address?.length > 100 ? "..." : ""
                      }`}
                </p>
              </div>

              {/* Actions */}
              <div className="flex items-center justify-between mt-4 border-t pt-3">
                <button
                  onClick={() => setShowMore((prev) => !prev)}
                  className="text-sm text-red-500 hover:text-[#DB0029]"
                >
                  {project?.address?.length > 99 &&
                    (showMore ? "Show less" : "Show more")}
                </button>

                <div className="flex gap-2 text-xs md:text-base">
                  <Link
                    to={`/${contactList}/${project._id}`}
                    className="btn btn-outline btn-xs text-blue-500 hover:text-blue-700 transition duration-150 rounded-lg"
                  >
                    <FaRegEdit size={20} />
                  </Link>
                  {user === "admin" && (
                    <button
                      onClick={handleDelete}
                      className="btn btn-outline btn-xs text-red-500 px-3 hover:text-red-700 transition duration-150 rounded-lg"
                    >
                      <MdDeleteForever size={23} />
                    </button>
                  )}
                </div>
              </div>
            </div>
          ) : (
            <Link
              to={`/${contactListAdd}`}
              className="flex justify-center items-center rounded-xl bg-gray-50 shadow-xl h-full"
            >
              <p className="text-8xl group-hover:text-[#DB0029]">
                <AiFillFileAdd />
              </p>
            </Link>
          )}
        </div>
      )}
    </>
  );
}

export default ContactsCard;
